module.exports = __webpack_public_path__ + "img/8.7c8bcc57.png";